'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var LayoutButton = exports.LayoutButton = undefined;

exports.LayoutButton = LayoutButton = function LayoutButton(refs) {
    var uiManager = refs.uiManager;

    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.button.Button', {
        text: i18n.layout,
        menu: {},
        handler: function handler() {
            uiManager.get('viewport').getLayoutWindow().show();
        }
    });
};
//# sourceMappingURL=LayoutButton.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/LayoutButton.js
 ** module id = 168
 ** module chunks = 0 1
 **/